import { render, staticRenderFns } from "./Comparasion.vue?vue&type=template&id=4ef0acea&scoped=true&"
import script from "./Comparasion.vue?vue&type=script&lang=js&"
export * from "./Comparasion.vue?vue&type=script&lang=js&"
import style0 from "./Comparasion.vue?vue&type=style&index=0&id=4ef0acea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef0acea",
  null
  
)

export default component.exports